module.exports = __webpack_public_path__ + "static/bearded_devil-61144be2d4123b4803c9bcc0e1f2295a.jpg";